import { client as defaultClient } from '@api/client';

import type {
    StoryCreated,
    StoryCurrent,
    StoryStatus,
    StoryUpload,
} from './types';

export async function storyUpload(data: StoryUpload): Promise<StoryCreated | undefined> {
    const story = await defaultClient.POST('/story/upload', { body: data });
    return story.data;
}

export async function storyDelete(id: string): Promise<void> {
    await defaultClient.DELETE('/story/{id}', {
        params: {
            path: {
                id,
            },
        },
    });
}

export async function storyStatus(id: string): Promise<StoryStatus | undefined> {
    const story = await defaultClient.GET('/story/{id}/status', { params: { path: { id } } });
    return story.data;
}

export async function getCurrentStory(): Promise<StoryCurrent | undefined> {
    const story = await defaultClient.GET('/story/current', {});
    return story.data;
}
